import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-volume-mid",
  templateUrl: "./med-icon-volume-mid.component.html",
})
export class MedIconVolumeMidComponent extends SvgMixinComponent {}
